/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment, useState } from 'react'

import { EuiButton } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import CreateUserModal from './CreateUserModal'

import type { FC } from 'react'

const CreateUserButton: FC = () => {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <Fragment>
      {modalOpen && <CreateUserModal closeModal={() => setModalOpen(false)} />}
      <EuiButton onClick={() => setModalOpen(true)}>
        <FormattedMessage id='users.create-user' defaultMessage='Create new user' />
      </EuiButton>
    </Fragment>
  )
}

export default CreateUserButton
